module.exports = __webpack_public_path__ + "img/15.08b1c999.png";